module.exports = __webpack_public_path__ + "static/media/mazda-app-icon.40124247.svg";